import { amountToPriceString } from '@caterdesk/utils--money'
import { Divider, Stack, Typography } from '@mui/material'
import type React from 'react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useVendorInRange } from '../states/useVendorInRange'

export type Props = {
  vendorId: string
  currency: string | null
}

const LocationDetails: React.FC<Props> = ({ vendorId, currency }) => {
  const { deliveryFee, minOrderFee } = useVendorInRange({
    vendorId,
  })

  const { t } = useTranslation()

  return (
    <Fragment>
      <Stack flexDirection="row" justifyContent="space-evenly">
        <Typography variant="body2">
          {amountToPriceString(currency || 'GBP', deliveryFee || 0, true)}{' '}
          <Typography variant="caption" color="text.secondary">
            {t('marketplace:deliveryFee')}
          </Typography>
        </Typography>

        <Typography variant="body2">
          {amountToPriceString(currency || 'GBP', minOrderFee || 0, true)}{' '}
          <Typography variant="caption" color="text.secondary">
            {t('marketplace:minimumOrder')}
          </Typography>
        </Typography>
      </Stack>

      <Divider sx={{ marginBottom: 2, marginTop: 2 }} />
    </Fragment>
  )
}
export default LocationDetails
